const KEY = 'acecast.recents'
const MAX = 12

export type Recent = { link: string; label: string; usedAt: number }

export function loadRecents(): Recent[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as Recent[]) : []
  } catch {
    return []
  }
}

export function rememberRecent(link: string, label?: string): Recent[] {
  const next: Recent[] = [
    { link, label: label?.trim() || shortLabel(link), usedAt: Date.now() },
    ...loadRecents().filter((r) => r.link !== link),
  ].slice(0, MAX)
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    // Private browsing or a full quota: recents are a convenience, not state.
  }
  return next
}

export function forgetRecent(link: string): Recent[] {
  const next = loadRecents().filter((r) => r.link !== link)
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* ignore */
  }
  return next
}

function shortLabel(link: string): string {
  const hash = /([0-9a-f]{40})/i.exec(link)?.[1]
  return hash ? `${hash.slice(0, 8)}…${hash.slice(-6)}` : link.slice(0, 40)
}
